import { usePOSDeviceRegister } from "@easybiz/api-pos";
import { useClientInstallId } from "@easybiz/component-shared";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";

function useQRSignInPanel(MobileAppLink, getDeviceInfo) {
  const installId = useClientInstallId();
  const { onSubmit, loading, response } = usePOSDeviceRegister();

  useEffect(() => {
    if (installId && onSubmit) {
      onSubmit({ ...getDeviceInfo(), installId });
    }
  }, [installId, onSubmit]);

  useEffect(() => {
    if (installId && onSubmit && Number.isInteger(response?.expireTime)) {
      const handler = setInterval(() => {
        if (response?.expireTime <= dayjs().unix()) {
          onSubmit({ ...getDeviceInfo(), installId });
        }
      }, 60000);

      return () => clearInterval(handler);
    }
  }, [response?.expireTime, installId, onSubmit]);

  return {
    title: <FormattedMessage defaultMessage={"Sign in with a code"} />,
    subTitle: (
      <FormattedMessage
        defaultMessage={
          "Enter the code below in the Sign In to POS feature available on the Console or in the <a>EasyBiz Cloud App</a> to connect your POS system."
        }
        values={{
          a: (t) => <MobileAppLink>{t}</MobileAppLink>,
        }}
      />
    ),
    qrTitle: <FormattedMessage defaultMessage={"QR Code"} />,
    qrSubTitle: (
      <FormattedMessage
        defaultMessage={"Scan this QR code using your <a>EasyBiz Cloud App</a>"}
        values={{
          a: (t) => <MobileAppLink>{t}</MobileAppLink>,
        }}
      />
    ),
    loading: loading,
    otp: response?.otp,
    displayOtp: response?.displayCode,
    onRetry: () => onSubmit({ ...getDeviceInfo(), installId }),
  };
}

export default useQRSignInPanel;
